import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = no, object = yes

  const check = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
    } catch {
      setAdmin(false);
    }
  };
  useEffect(() => { check(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setAdmin({ email: data.email, name: data.name });
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setAdmin(false);
  };

  return <AuthContext.Provider value={{ admin, login, logout, recheck: check }}>{children}</AuthContext.Provider>;
}
